import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ja from './locales/ja.json'

const messages = {
    en,
    ja
}

console.log('[i18n] Loaded messages:', messages)

const i18n = createI18n({
    legacy: false, // Composition API mode
    globalInjection: true, // テンプレート内で $t を使えるようにする（重要！）
    locale: navigator.language.split('-')[0] === 'ja' ? 'ja' : 'en',
    fallbackLocale: 'en',
    messages
})

export default i18n
